








import $ from "jquery"
import Vue, {PropType} from 'vue'

export default Vue.extend({
  props: {
    fontChoices: {
      type: Array as PropType<Array<string>>,
      default: function() {
        return [
          "Roboto",
          "Avenir",
          "Helvetica",
          "Arial",
          "sans-serif"
        ]
      }
    }
  },
  data: function() {
    return {
      font: ''
    }
  },
  methods: {
    changeFont: function() {
      $('#app').css('font-family', this.font)
    }
  }
})
